<template>
    <div v-if="load == true">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <div>
            <v-card class="box">
                <v-toolbar dense class="toolbar" flat>
                    <v-toolbar-title>Select Employee Name</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense justify="center">
                    <v-col cols="12" md="6" class="pt-4">
                        <v-autocomplete rounded outlined dense v-model="emppersonname" :items="emplist" @click="abc()"
                            return-object v-on:change="employeedisplaydata()" item-text="empnameandcode"
                            item-value="empid" label="Select Employee" prepend-icon="mdi-account" />
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="box" v-if="this.empdetailslist.length > cnt">
                <v-toolbar dense class="toolbar" flat>
                    <v-toolbar-title> Employee Information Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar> <br>
                <v-simple-table dense class="elevation-1 mytable">
                    <thead>
                        <tr>
                            <th>Employee Code</th>
                            <th>Employee Name</th>
                            <th>Contact No.</th>
                            <th>Contact Email</th>
                            <th>Employee Designation</th>
                            <th>Employee Type</th>
                            <th v-if="org_id == 'zeal'">Employee Payment Section</th>
                            <th v-if="org_id == 'zeal'">Employee Shift</th>
                            <th>Release Date</th>
                            <th>Currently Working</th>
                            <th>Is Central Leave Approval Required ?</th>
                            <th>Reset Password</th>
                            <th>Remove Access</th>
                            <th>Sync Salary Register</th>
                            <th>Update</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in empdetailslist" :key="item.id">
                            <td>{{ item.empcode }}</td>
                            <td>{{ item.empname }}</td>
                            <td>{{ item.empmobno }}</td>
                            <td>{{ item.empmail }}</td>
                            <td>{{ item.empdesignation }}</td>
                            <td>{{ item.emptype }}</td>
                            <td v-if="org_id == 'zeal'">{{ item.emp_payment_section }}</td>
                            <td v-if="org_id == 'zeal'">{{ item.emp_shift }}</td>
                            <td>
                                <span v-if="!item.working">
                                    <br>
                                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                                        transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field style="width: 150px;" dense
                                                @blur="date = parseDate(item.date_of_release)" hint="YYYY/MM/DD format"
                                                persistent-hint v-model="item.date_of_release" label="Date Of Release"
                                                readonly v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="item.date_of_release"
                                            @input="menu3 = false"></v-date-picker>
                                    </v-menu>
                                </span>
                                <span v-else> -- </span>
                            </td>
                            <td>
                                <v-checkbox v-model="item.working" color="success" hide-details dense
                                    @change="onWorkingToggle(item)">
                                </v-checkbox>
                            </td>
                             <td>
                                <v-checkbox v-model="item.is_central_leave_approval_required" color="success" hide-details dense>
                                </v-checkbox>
                            </td>
                            <td>
                                <v-checkbox v-model="item.reset_password" v-if="!item.working" color="success"
                                    hide-details dense />
                            </td>
                            <td>
                                <v-checkbox v-model="item.remove_access" v-if="!item.working" color="success"
                                    hide-details dense />
                            </td>

                            <td>
                                <v-checkbox v-model="item.sync_salary_register" color="success" hide-details
                                    dense></v-checkbox>
                            </td>
                            <td>
                                <v-btn small class="button" @click="onUpdate(item)">Update</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card>

            <v-card class="box" v-if="
                this.empdetailslist.length > cnt &&
                this.empdetailslist != null &&
                this.allempdesignationlist != null
            ">
                <v-toolbar dense class="toolbar" flat>
                    <v-toolbar-title>Edit Employee Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row dense justify="center">
                    <v-col cols="12" md="4" sm="4" class="pt-4">
                        <v-autocomplete rounded outlined dense v-model="empdesignation" :menu-props="{ offsetY: true }"
                            :items="allempdesignationlist" item-value="empdesignationid" item-text="allempdesg"
                            label="Select Employee Designation" prepend-icon="mdi-account" />
                    </v-col>

                    <v-col cols="12" md="4" sm="4" class="pt-4">
                        <v-autocomplete rounded outlined dense v-model="emptypename" :items="allemptypelist"
                            item-value="emptypeid" item-text="allemptype" label="Select Employee Type"
                            prepend-icon="mdi-account" />
                    </v-col>
                </v-row>

                <v-row dense justify="center">
                    <v-col cols="12" md="4" sm="4" class="pt-4" v-if="allemppaymentsectionlist != ''">
                        <v-autocomplete rounded outlined dense v-model="section" :items="allemppaymentsectionlist"
                            item-value="id" item-text="name" label="Select Employee Payment Section"
                            prepend-icon="mdi-account-settings" />
                    </v-col>
                    <v-col cols="12" md="4" sm="4" class="pt-4" v-if="allempshiftlist != ''">
                        <v-autocomplete rounded outlined dense v-model="shift" :items="allempshiftlist" item-value="id"
                            item-text="name" label="Select Employee Shift" prepend-icon="mdi-account-plus" />
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-btn v-on:click="editEmployee()" class="mb-2 button">Save </v-btn>
                </v-row>
            </v-card>

        </div>

        <!-- <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th>
            Employee Name
          </th>
          
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in emplist"
          :key="item.id"
        >
          <td>{{ item.empname }}</td>
          
        </tr>
      </tbody>
    </template>
  </v-simple-table> -->
    </div>
</template>

<script>
import axios from "axios";

import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            emppersonname: "",
            empdesignation: null,
            emptypename: null,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",

            snackbar_msg: "",
            cnt: 0,
            color: "",
            snackbar: false,
            search: "",
            load: false,
            emplist: {},
            empdetailslist: {},
            allempdesignationlist: null,
            allemptypelist: null,
            allemppaymentsectionlist: [],
            section: null,
            allempshiftlist: [],
            shift: null,
            org_id: null,
            menu3: false,
            reset_password: false,
            remove_access: false,
        };
    },
    mounted() {
        this.org_id = localStorage.getItem("EPS-tenant");
        this.load = false;
        axios
            .post("/Employee/editEmployee")
            .then((res) => {
                if (res.data.msg == "200") {
                    this.emplist = res.data.emplist;
                    this.load = true;
                } else {
                }
            })
            .catch((error) => {
                window.console.log(error);
            });
    },

    methods: {
        onUpdate(item) {
            if (!item.working && item.reset_password) {
                this.resetPassword(item);
            }

            if (!item.working && item.remove_access) {
                this.removeAccess(item);
            }


            if (!(item.reset_password || item.remove_access)) {
                this.toggleWorking(item);
            }
        },

        toggleWorking(item) {
            if (item.working == false) {
                if (item.date_of_release == null || item.date_of_release == '') {
                    this.showSnackbar("red", "Please add released date");
                    return false
                }
            }
            axios
                .post("/Employee/toggleIsWorkingemployee", item)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Save Successfuly");
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("red", "Something went wrong!!!");
                })
                .finally(() => { });
            return true;
        },
        abc() {
            this.allempdesignationlist = null;
            this.allemptypelist = null;
            this.empdesignation = null;
            this.emptypename = null;
        },
        editEmployee() {
            const data = {
                emptypeid: this.emptypename,
                empdesignationid: this.empdesignation,
                empid: this.emppersonname,
                section: this.section,
                shift: this.shift
            };

            axios.post("/Employee/updateInfo", data).then((res) => {
                if (res.data.flag == "yes") {
                    this.showSnackbar("#4caf50", "Updated Successfully...");
                    this.employeedisplaydata();
                }
            })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrongt!!!");
                })
                .finally(() => {
                    this.empdesignation = null,
                        this.emptypeid = null,
                        this.section = null,
                        this.shift = null
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        employeedisplaydata() {
            //alert(this.emppersonname.empid);
            const data = {
                empid: this.emppersonname,
            };

            axios
                .post("/Employee/getEmployeeDetails", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.empdetailslist = res.data.empdetailslist;
                        this.allempdesignationlist = res.data.allempdesignationlist;
                        this.allemptypelist = res.data.allemptypelist;
                        this.allempshiftlist = res.data.allempshiftlist;
                        this.allemppaymentsectionlist = res.data.allemppaymentsectionlist;
                        //alert(this.allemptypelist)
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
        },

        resetPassword(item) {
            axios
                .post("/Employee/resetPassword", item)
                .then((res) => {
                    if (res.data.code === "SUCCESS") {
                        this.showSnackbar("#4caf50", "Password Reset Successfully");
                    } else if (res.data.code === "NA") {
                        this.showSnackbar("#b71c1c", "Login is blocked for this user");
                    } else {
                        this.showSnackbar("#b71c1c", res.data.msg || "Something Went Wrong!!!");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("#b71c1c", "Something Went Wrong!!!");
                });
        },

        removeAccess(item) {
            axios
                .post("/Employee/removeAccess", item)
                .then((res) => {
                    if (res.data.code === "SUCCESS") {
                        this.showSnackbar("#4caf50", "Access Removed Successfully");
                    } else if (res.data.code === "NA") {
                        this.showSnackbar("#b71c1c", "Login is blocked for this user");
                    } else {
                        this.showSnackbar("#b71c1c", res.data.msg || "Something Went Wrong!!!");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("#b71c1c", "Something Went Wrong!!!");
                });
        },


        onWorkingToggle(item) {
            if (item.working) {
                item.reset_password = false;
                item.remove_access = false;
            }
        }


    },
};
</script>
<style scoped>
.delete-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.delete-avatar:hover {
    background-color: #b0bec5;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.mytable th,
.mytable td {
    text-align: center !important;
    vertical-align: middle;
}

.mytable td .v-input--selection-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
}

.mytable td .v-input {
    margin-top: 0;
}
</style>
